import React, { ReactElement } from "react";
import styles from "./FormGenericErrorMessage.module.scss";
import { Icon } from "../../Icon/Icon";

export interface FormGenericErrorMessageProps {
  message: string | ReactElement;
}

export const FormGenericErrorMessage: React.FC<
  React.PropsWithChildren<FormGenericErrorMessageProps>
> = ({ message }) => {
  return (
    <div className={styles.error}>
      <Icon name="alert" padding={false} className={styles.icon} />
      {message}
    </div>
  );
};
